// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"679997e6","171":"11032ae6","425":"fce28b92","989":"d849cb1e"}[chunkId] + ".chunk.js";
};